import { Component, Input } from '@angular/core';
import { SettingsService } from 'src/app/services/account/settings.service';

@Component({
  standalone: true,
  selector: 'app-battery',
  templateUrl: './battery.component.html',
  styleUrls: ['./battery.component.scss']
})
export class BatteryComponent {
  @Input() batteryLevel;

  constructor(public settingsService: SettingsService) { }

}
